import apiClient from './client';

export interface BonusCalculateForCartResponse {
  maxToUse: number;
  hasPromoItems: boolean;
  subtotalRegular: number;
  cashbackPercent: number;
}

export async function calculateBonusForCart(items: { productId: number; quantity: number }[]): Promise<BonusCalculateForCartResponse> {
  const response = await apiClient.post<{ data: BonusCalculateForCartResponse }>('/api/bonus/calculate-for-cart', {
    items,
  });
  return response.data?.data ?? { maxToUse: 0, hasPromoItems: false, subtotalRegular: 0, cashbackPercent: 0 };
}
